import cn from 'classnames';
import type React from 'react';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import * as st from './styles.module.scss';

type Props = {
  id: number;
  isIndividualCoachCard?: boolean;
};

export const Description: React.FC<Props> = ({ id, isIndividualCoachCard = false }) => {
  const { data: coach } = useCoachQuery({ id: String(id) });

  return (
    <>
      {coach?.description && <article className={cn(st.description)}>{coach.description}</article>}
    </>
  );
};
